import type { FC, SVGProps } from 'react';

const Twitter: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.278 18.429c-2.311 0-4.465-.672-6.278-1.832 1.54.1 4.256-.14 5.945-1.75-2.541-.117-3.688-2.067-3.837-2.9.216.083 1.246.183 1.827-.05C1.011 11.164.563 8.598.662 7.815c.549.383 1.479.516 1.845.483C-.218 6.348.762 3.416 1.244 2.783c1.955 2.709 4.885 4.23 8.51 4.315a4.19 4.19 0 0 1-.104-.933A4.16 4.16 0 0 1 13.803 2c1.199 0 2.279.51 3.037 1.323.8-.187 2.006-.627 2.595-1.006-.297 1.066-1.221 1.955-1.78 2.285-.005-.011.004.011 0 0 .49-.074 1.82-.33 2.345-.686-.26.6-1.24 1.595-2.044 2.153.15 6.601-4.901 12.36-11.678 12.36Z"
      fill="#47ACDF"
    />
  </svg>
);

export default Twitter;
